'use client';

import { classNames } from "../../../utils/styles/classNames.js";
import { full, borderWidth, container, borderColor } from "../Button.css.js";
import { getCssVariant } from "./getCssVariant.js";
import { hasBorder } from "./hasBorder.js";
function getAnchorContainerClassNames(p) {
  return classNames(
    p.className,
    container,
    hasBorder(p) ? borderWidth.regular : borderWidth.none,
    pickBorderColor(p),
    p.fullWidth && full,
    getCssVariant(p)[p.onDark ? "onDark" : "onLight"]
  );
}
function pickBorderColor(p) {
  return borderColor[p.onDark ? "emphasisDark" : "emphasis"];
}
export {
  getAnchorContainerClassNames
};
